<vs-dialog [config]="{ dialogContainerClass: 'max-w-[560px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      icon: 'coins-stacked-02',
      iconTheme: 'primary',
      title: line ? controlsConfig.chargeDialog.editTitle : controlsConfig.chargeDialog.addTitle,
      subtitle: controlsConfig.chargeDialog.subtitle
    }"
  ></vs-dialog-header>

  <form class="flex flex-col gap-4 p-4" [formGroup]="form">
    <div class="grid grid-cols-2 gap-4">
      <vs-form-field [config]="{ label: controlsConfig.chargeDialog.type }">
        <vs-select vsInput formControlName="category">
          <li *ngFor="let category of categories" vs-select-option [value]="category">{{ category | titlecase }}</li>
        </vs-select>
      </vs-form-field>

      <vs-form-field [config]="{ label: controlsConfig.chargeDialog.currency }">
        <!-- Set by the claim, not picked here. -->
        <input vsInput type="text" formControlName="currency" readonly />
      </vs-form-field>
    </div>

    <vs-form-field [config]="{ label: controlsConfig.chargeDialog.description }">
      <input
        vsInput
        type="text"
        formControlName="description"
        [placeholder]="controlsConfig.chargeDialog.descriptionPlaceholder"
      />
    </vs-form-field>

    <div class="grid grid-cols-3 gap-4">
      <vs-form-field [config]="{ label: controlsConfig.chargeDialog.quantity }">
        <input vsInput type="number" min="0" step="any" formControlName="quantity" placeholder="1.5" />
      </vs-form-field>

      <vs-form-field [config]="{ label: controlsConfig.charges.unitLabel }">
        <vs-select
          vsInput
          formControlName="unitCode"
          [config]="{ placeholder: controlsConfig.charges.unitPlaceholder }"
        >
          <li *ngFor="let unit of units" vs-select-option [value]="unit.code">{{ unit.label }}</li>
        </vs-select>
      </vs-form-field>

      <vs-form-field [config]="{ label: controlsConfig.chargeDialog.rate }">
        <input vsInput type="number" min="0" step="0.01" formControlName="rate" placeholder="120.00" />
      </vs-form-field>
    </div>

    <vs-form-field [config]="{ label: controlsConfig.chargeDialog.requestedAmount }">
      <input vsInput type="number" min="0" step="0.01" formControlName="requestedAmount" placeholder="180.00" />
    </vs-form-field>

    <div class="flex gap-6 items-center">
      <label class="flex items-center gap-2 text-sm text-gray-700 whitespace-nowrap">
        <input type="checkbox" formControlName="taxable" />
        {{ controlsConfig.chargeDialog.taxable }}
      </label>

      <vs-form-field class="min-w-0" [config]="{ label: controlsConfig.chargeDialog.taxRate }">
        <input vsInput type="number" min="0" max="100" step="any" formControlName="taxRatePercent" placeholder="6.5" />
      </vs-form-field>
      <label class="flex items-center gap-2 text-sm text-gray-700 whitespace-nowrap">
        <input type="checkbox" formControlName="taxInclusive" />
        {{ controlsConfig.chargeDialog.taxInclusive }}
      </label>
    </div>
  </form>

  <div class="flex justify-end gap-2 px-4 pb-4">
    <button vs-button appearance="outline" (click)="close()">{{ controlsConfig.chargeDialog.cancel }}</button>
    <button vs-button theme="primary" [disabled]="form.invalid" (click)="save()">
      {{ line ? controlsConfig.chargeDialog.save : controlsConfig.chargeDialog.add }}
    </button>
  </div>
</vs-dialog>
